import type { FAIconName } from "@/ui/core";
import { Icon, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface GroupSectionDetailRowProps extends ViewWithTestID {
  icon: FAIconName;
  text: string;
}

// icon + text row used in the registered-section card and the confirm-registration sheet
const GroupSectionDetailRow = ({
  icon,
  testID,
  text,
}: GroupSectionDetailRowProps) => (
  <HStack alignItems="center" gap={8}>
    <Icon
      color={ColorToken.NeutralPrimary}
      name={icon}
      size="sm"
      testID={joinTestIDs(testID, "icon")}
    />
    <Text testID={testID} variant="body">
      {text}
    </Text>
  </HStack>
);

export default GroupSectionDetailRow;
